import React from 'react'
import Box from 'components/Box'
import Image from 'components/Image'
import Text from 'components/Text'
import 'styles/PromoMaior.css'

export default () => {
  return (
    <React.Fragment>
      <Box padded classes={`-headPadding`}>
        <div className='PromoMaior'>
          <div className='PromoMaior-column'>
            <Text className="SectionTitle" style={{color: '#333333', fontWeight: 800}}>
              Já é assinante de algum sistema de questões? 
            </Text>
            <Text style={{color: '#333333', fontWeight: 600}}>
              Então envie-nos o comprovante com gasto acima de<br />R$ 100,00 e ganhe descontos exclusivos.
            </Text>
          </div>
          <div className='PromoMaior-column'>
            <Image
              className='PromoMaior-featured-img'
              src={require('images/promomaior.png')}
              alt='Promoção #VemParaOMaior'
              center
            />
          </div>
        </div>
      </Box>
    </React.Fragment>
  )
}
